module.exports = __webpack_public_path__ + "img/error.d96d7397.svg";